import { withInstall } from '@zoryn/utils'
import Scrollbar from './src/scrollbar.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZScrollbar: SFCWithInstall<typeof Scrollbar> =
  withInstall(Scrollbar)
export default ZScrollbar

export * from './src/util'
export * from './src/scrollbar'
export * from './src/thumb'
export * from './src/constants'
